import React from 'react';
import Matches from '../components/Matches';

const AllMatches = () => {
    return <Matches userId={null} title="All matches for location" cacheKeyPrefix="all" />;
};

export default AllMatches;